const BASE_URL = "https://ventmoir.onrender.com";

export const WEBSITE_URL = window.location.href;

export const Constants = {
  API_URL: "https://ventmoir.onrender.com",
  AUTH_TOKEN_KEY: "auth_token",
  PAGE_SIZE: 10,
};
